import React from 'react';
import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer,
  Legend
} from 'recharts';
import { useTranslation } from 'react-i18next';

const APPETITE_CATEGORY_KEYS = {
  Averse: "generalDashboard.appetite.averse",
  Minimalist: "generalDashboard.appetite.minimalist",
  Cautious: "generalDashboard.appetite.cautious",
  Open: "generalDashboard.appetite.open",
  Hungry: "generalDashboard.appetite.hungry",
};

const RiskAppetite = ({ height, risk_appetite }) => {
  const { t } = useTranslation();
  // Prepare data with both target and real values
  const transformedData = risk_appetite?.map(({ category, target, real }) => ({

    category,
    target,
    real,
  }));

  return (
  <ResponsiveContainer width="100%" height={height}>
      <RadarChart data={transformedData} margin={{ top: 60, right: 15, bottom: 0, left: 0 }}>
        <PolarGrid gridType="circle" />
        <PolarAngleAxis
    dataKey="category"
    tick={{ fontSize: 10, fill: '#555' }}
    tickLine={false}
    tickFormatter={(value) => {
      const key = APPETITE_CATEGORY_KEYS[value];
      return key ? t(key) : value;
    }}
  />        <PolarRadiusAxis />
        <Radar
          name={t("generalDashboard.appetite.targetAppetite")}
          dataKey="target"
          stroke="#0A4E62"
          fill="#0A4E62"
          fillOpacity={0.3}
        />
        <Radar
          name={t("generalDashboard.appetite.realAppetite")}
          dataKey="real"
          stroke="#F07167"
          fill="#F07167"
          fillOpacity={0.3}
        />
        <Legend
          iconType="circle"           // keep your circle icons
          iconSize={10}               // ↓ default is 14 px – try 8-12 px
          wrapperStyle={{
            fontSize: 12,             // ↓ default is ~14 px
            lineHeight: '12px',       // tighten vertical spacing
            bottom: 10,              // pull the legend a bit closer
          }}
        />      
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default RiskAppetite;